/**
 * Append random string to search input name attribute to circumvent Chrome autofill arrogance.
 * @param {string} name input name
 */
export const generateNameToFoolChromeAutofill = (name: any) => name + Math.random().toString(30).substring(2)
